







































import { Component, Prop, Vue } from 'vue-property-decorator';
import Assets from '@/constants/assets';

export enum ModalTitleColor {
  Default = '',
  Primary = 'modal__header--title--primary-color',
  Secondary = 'modal__header--title--secondary-color',
  GreenMiddle = 'modal__header--title--green-middle-color',
}

export enum ModalPredefinedStyle {
  Default = '',
  OverflowVisible = 'modal-container--overflow-visible',
}

export enum ModalWidth {
  Default = 'modal--default-width',
  Medium = 'modal--medium-width',
}

export enum CustomHeight {
  Default = 'modal--default-height',
  Custom = 'modal--custom-height',
}

@Component
export default class Modal extends Vue {
  @Prop() private title!: string;
  @Prop() private subtitle!: string;
  @Prop({ default: ModalTitleColor.Default })
  private titleBackgroundColor!: ModalTitleColor;
  @Prop({ default: ModalTitleColor.Secondary })
  private subtitleBackgroundColor!: ModalTitleColor;
  @Prop({ default: ModalWidth.Default }) private modalWidth!: ModalWidth;
  @Prop({ default: CustomHeight.Default }) private customHeight!: CustomHeight;
  @Prop() private isOpen!: boolean;
  @Prop({ default: false }) private overflowAuto!: boolean;
  @Prop({ default: false }) private squared!: boolean;
  @Prop() private predefinedStyle!: ModalPredefinedStyle;

  private assets = Assets;

  // METHODS
  private closeModal(event: any) {
    if (
      event.target.className === 'modal-container' ||
      event.target.className === 'modal__icon-close'
    ) {
      this.$emit('closing-modal');
    }
  }

  private hasSlotContent(slotName: string) {
    return !!this.$slots[slotName];
  }
}
